<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_gameWithTime') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='selectedGameType',
                        @select='params.withTime = $event.withTime'
                    )
            .form__field(v-if="params.withTime && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.showTime"
                        :placeholder="timeLimitLabel(params.showTime)"
                        :custom-label="timeLimitLabel"
                        :multiple="false"
                        :allow-empty="false"
              )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('support.support_createTicket_theme') }}
                .form__field-body
                    cs-multiselect(
                        v-model="params.selectedTheme"
                        @select="selectGameTheme",
                        label="name",
                        track-by="name",
                        :options="themes",
                        :multiple="false",
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseTheme')",
                        :searchable="false",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfRows') }}
                .form__field-body
                    cs-spin-input(
                        v-model="params.amountOfRows",
                        :max="20",
                        :min="3",
                        @increase="params.amountOfRows++",
                        @decrease="params.amountOfRows--",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_chooseElements') }}
                .form__field-body
                    cs-spin-input(
                        v-model="params.amountOfItems",
                        :max="6",
                        :min="2",
                        @increase="params.amountOfItems++",
                        @decrease="params.amountOfItems--",
                    )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="params.selectedTheme && params.selectedTheme.length < 1")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="params.selectedTheme && params.selectedTheme.length < 1")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="params.selectedTheme && params.selectedTheme.length < 1")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "@/utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import IntervalConfig from "../../trainer/configs/IntervalConfig";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";

    const Themes = function(courseType) {
        const obj = {
            mentalArithmetic: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_digits'),
                    theme: 'digits',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_englishLetters'),
                    theme: 'englishLetters',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_computationalSet'),
                    theme: 'computationalSetBlack',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_abcOfSanskrit'),
                    theme: 'abcOfSanskrit',
                },
            ],
            fastReading: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_syllables'),
                    theme: 'syllables',
                },
                {
                    name: this.$i18n.tc('trainer.trainer_gameFormSetting_letters', 1),
                    theme: 'letters',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_pictograms'),
                    theme: 'pictograms',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_arrows'),
                    theme: 'arrows',
                },
            ],
            onlineSchool: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_childrensSet'),
                    theme: 'childrensSet',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_abcOfSanskrit'),
                    theme: 'abcOfSanskrit',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_syllables'),
                    theme: 'syllables',
                },
                {
                    name: this.$i18n.tc('trainer.trainer_gameFormSetting_letters', 1),
                    theme: 'letters',
                },
            ],
            mathMagic: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_arrows'),
                    theme: 'arrows',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_digits'),
                    theme: 'digits',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_englishLetters'),
                    theme: 'englishLettersBig',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_ringsOfLandolt'),
                    theme: 'ringsOfLandolt',
                },
            ],
            memoryDevelopment: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_computationalSet'),
                    theme: 'computationalSetColored',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSettingValue_symbol'),
                    theme: 'symbol',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_ringsOfLandolt'),
                    theme: 'ringsOfLandolt',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_halfPoints'),
                    theme: 'halfPoints',
                },
            ],
            multiplication: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_digits'),
                    theme: 'digits',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_englishLetters'),
                    theme: 'englishLetters',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_computationalSet'),
                    theme: 'computationalSetBlack',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_abcOfSanskrit'),
                    theme: 'abcOfSanskrit',
                },
            ],
            readingEn: [
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_abcOfSanskrit'),
                    theme: 'abcOfSanskrit',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_pictograms'),
                    theme: 'pictograms',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_ringsOfLandolt'),
                    theme: 'ringsOfLandolt',
                },
                {
                    name: this.$i18n.t('trainer.trainer_gameFormSetting_arrows'),
                    theme: 'arrows',
                },
            ],
        };
        return obj[courseType];
    };

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                gameTypes: [
                    {
                        name: this.$i18n.t('common.common_gameName_correctiveSamplesWithoutTime'),
                        withTime: false
                    },
                    {
                        name: this.$i18n.t('common.common_gameName_correctiveSamplesWithTime'),
                        withTime: true
                    }
                ],
                seconds: IntervalConfig.timeLimitForMentalDrawing,
                selectedGameType: null,
                params: null,
            }
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                                default: _.cloneDeep(this.gamesParameters[this.slug]),
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
        },
        methods: {
            selectGameTheme(value) {
                this.params.selectedTheme = value.theme;
            },
            timeLimitLabel(amount) {
                return amount === 0
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                    : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
            },
        },
        updated () {
            this.selectedGameType = _.find(this.gameTypes, { withTime: this.params.withTime });
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            themes() {
                return Themes.call(this, this.currentCourseType);
            },
            currentCourseType() {
                if (this.courseType) return this.courseType;
                if (this.$route.params.coursesType) return this.$route.params.coursesType;
                if (this.homework.games[this.$route.params.gameId].courseType)
                    return _.camelCase(this.homework.games[this.$route.params.gameId].courseType);
                return null;
            },
        },
        watch: {
            'params.withTime': {
                handler (val) {
                    !this.params.showTime && val && (this.params.showTime = this.seconds[0]);
                    !val && (this.params.showTime = null);
                }
            },
            'params.selectedTheme': {
                handler (val) {
                    if (val && !this.themes.find(({ theme }) => theme === this.params.selectedTheme.theme)) {
                        this.params.selectedTheme = null;
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

